export default __webpack_public_path__ + "static/media/productdetailpage.c1aaa927.jpg";